import PaletteTheme from './Palette';
import BreakpointsTheme from './Breakpoints';

const theme = {
  palette: PaletteTheme,
  breakpoints: BreakpointsTheme,
};

export default theme;
